// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1KkmP","content":"LoadingAlert_content__1Lrw6"};